import { track, trackingEvents } from 'modules/core/lib/Tracking'
import asyncAction from 'modules/core/lib/asyncAction'

import type Employee from 'modules/employees/store/models/Employee'
import type LeaveForm from 'modules/timeoff/lib/LeaveForm'
import { leaveEmployee } from 'modules/timeoff/lib/leaveEmployees'
import type Leave from 'modules/timeoff/store/models/Leave'

interface ApproveAndRefreshLeaveParams {
  action: string
  rpcMethod: string
  leave: Leave
  form: LeaveForm
  canUpdate: boolean
  onFetchStats: () => void
  fetchData: (employee: Employee) => void
  closePortal: () => void
  onClose: () => void
  fromShifts?: boolean
}

export async function approveAndRefreshLeave({
  action,
  rpcMethod,
  leave,
  form,
  canUpdate,
  onFetchStats,
  fetchData,
  closePortal,
  onClose,
  fromShifts = false,
}: ApproveAndRefreshLeaveParams) {
  if (canUpdate) {
    const { success } = await asyncAction(() => form.save(leave))
    if (!success) {
      return
    }
  }

  const { success, value } = await asyncAction(() => leave.rpc(rpcMethod))
  if (success) {
    onFetchStats()
    leave.set(value)
    fetchData(leaveEmployee(leave))
    closePortal()
    onClose()
    track(trackingEvents.timeoff.reviewTimeOffRequestSubmit, {
      request_action: action,
      from_shifts: fromShifts,
    })
  }
}
